import React, { useState } from "react";
import ListView, { ListViewItem } from "@ingka/list-view";
import magnifyingGlass from "@ingka/ssr-icon/paths/magnifying-glass";
import { useToastNotification } from "@coworker/components";
import { useTranslation } from "@coworker/locales";
import { useInputPopup } from "../../InputPopup";
import { fetchArticlesInfo } from "../../../hooks/API/tasks.service.helper";
import { ReplacedArticleListItem } from "../Molecules/ReplacedArticleListItem";
import { LargeSkeletonListItem } from "../Molecules/skeletons/LargeSkeletonListItem";
import { ArticleInfo, ArticlesInfo } from "../types/article";

interface ReplaceProductProps {
  oldProductArticleIds: string[];
  setNewArticle: (newArticle: ArticleInfo) => void;
}

export const ReplaceProduct = ({
  oldProductArticleIds,
  setNewArticle,
}: ReplaceProductProps) => {
  const { t } = useTranslation();
  const { getInput } = useInputPopup();
  const { showToast } = useToastNotification();

  const [loading, setLoading] = useState(false);
  const [newArticleInfo, setNewArticleInfo] = useState<
    ArticleInfo | undefined
  >();

  async function onReplaceArticle() {
    setLoading(true);
    const { product } = await getInput("scansearch", {
      start: new Date(),
      forbiddenArticles: oldProductArticleIds,
      onForbiddenArticle: () => {
        showToast(
          t("productAlreadyExistInRoomString"),
          undefined,
          undefined,
          5
        );
      },
    });
    if (product) {
      const articlesInfo: ArticlesInfo = await fetchArticlesInfo(product);

      if (articlesInfo.length > 0) {
        const articleInfo = articlesInfo[0];
        if (articleInfo) setNewArticle(articleInfo);
        setNewArticleInfo(articleInfo);
        setLoading(false);
      }
    }
  }

  return (
    <div onClick={() => onReplaceArticle()}>
      <ListView id="replace-product-list" size={"small"}>
        <ListViewItem
          title={t("newProductString")}
          leadingIcon={magnifyingGlass}
          control={"navigational"}
          controlIcon={"chevronRightSmall"}
          emphasised
          inset
        />
      </ListView>
      {loading && <LargeSkeletonListItem />}
      <ReplacedArticleListItem articleInfo={newArticleInfo} />
    </div>
  );
};
